import React from "react"
import SliderGraficiRegionali from "../../slider/SliderGraficiRegionali"

function TabGrafici(props: any) {
    //console.log("macro area tab grafici, " ,props);
    return (
        <div id="tab-reverse-grafici" role="tabpanel">
            <div className="row">
                <div className="col-12">
                    <SliderGraficiRegionali
                        datiRegionali={props.datiRegionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroarea}
                        anno={props.anno}
                    />
                </div>
            </div>
        </div>
    )
}
export default TabGrafici
